const styles = {
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#151515",
    fontFamily: "'Montserrat', sans-serif",
    color: "#ffffff",
  },
  header: {
    backgroundColor: "#D9302E",
    color: "#ffffff",
    padding: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "20px",
    fontWeight: "600",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
  },
  title: {
    textTransform: "uppercase",
  },
  close: {
    cursor: "pointer",
    fontSize: "24px",
    marginLeft: "15px",
    color: "#ffffff",
    background: "none",
    border: "none",
  },
  clearButton: {
    backgroundColor: "#ffffff",
    color: "#D9302E",
    border: "none",
    padding: "6px 14px",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    marginRight: "10px",
    fontSize: "14px",
  },
  chatWindow: {
    flex: 1,
    overflowY: "auto",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    backgroundColor: "#3D3D43",
  },
  message: {
    display: "flex",
  },
  bubble: {
    padding: "0px 15px",
    borderRadius: "10px",
    maxWidth: "75%",
    fontSize: "14px",
    backgroundColor: "#661618",
    color: "#ffffff",
  },
  inputArea: {
    display: "flex",
    padding: "15px",
    borderTop: "1px solid #2D2D2D",
    backgroundColor: "#151515",
  },
  input: {
    flex: 1,
    padding: "10px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #333",
    marginRight: "10px",
    backgroundColor: "#ffffff",
    color: "#000000",
  },
  sendButton: {
    backgroundColor: "#D9302E",
    color: "#ffffff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "14px",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    margin: "1em 0",
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "14px",
    color: "#ffffff",
  },
  th: {
    border: "1px solid #aa0000",
    padding: "8px 12px",
    textAlign: "left",
    backgroundColor: "#8b1a1a",
  },
  td: {
    border: "1px solid #aa0000",
    padding: "8px 12px",
    textAlign: "left",
  },
  tbodyTrEven: {
    backgroundColor: "#5c1212",
  },
  // Graph styles
 graphContainer: {
    marginTop: 12,
    paddingBottom: 6,
  },
  graphImage: {
    maxWidth: "100%",
    borderRadius: "8px",
    border: "1px solid #ddd",
    display: "block",
  },
  graphButtonContainer: {
    position: "absolute",
    bottom: 10,
    right: 10,
    display: "flex",
    gap: 8,
  },
  graphButton: {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  },
  // Modal styles
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "20px",
  },
  modalContent: {
    position: "relative",
    maxWidth: "95%",
    maxHeight: "95%",
  },
  modalImage: {
    maxWidth: "100%",
    maxHeight: "90vh",
    objectFit: "contain",
    borderRadius: "8px",
  },
  modalCloseButton: {
    position: "absolute",
  
    right: -80,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    color: "#333",
    border: "none",
    borderRadius: "6px",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "18px",
    fontWeight: "bold",
  },
  modalDownloadButton: {
    position: "relative",
    top: -40,
    right: 80,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    color: "#333",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  },
};

export default styles;